import React, { createContext, useState, useContext } from 'react';

// Глобальный контекст для кэширования результатов поиска
// NomenclatureSearch сохраняет результаты сюда, модалка читает отсюда

const SearchResultsContext = createContext();

export const SearchResultsProvider = ({ children }) => {
  const [cachedResults, setCachedResults] = useState(new Map());

  // Сохранить результаты поиска в кэш
  const cacheSearchResults = (query, results) => {
    const normalizedQuery = query.toLowerCase().trim();
    console.log(`💾 [CACHE] Сохраняем результаты поиска для: "${normalizedQuery}"`, results.length);

    setCachedResults(prev => {
      const newCache = new Map(prev);
      newCache.set(normalizedQuery, {
        results,
        timestamp: Date.now(),
        query: normalizedQuery
      });
      return newCache;
    });
  };

  // Получить результаты поиска из кэша
  const getCachedSearchResults = (query) => {
    const normalizedQuery = query.toLowerCase().trim();
    const cached = cachedResults.get(normalizedQuery);

    if (cached) {
      const age = Date.now() - cached.timestamp;
      const maxAge = 5 * 60 * 1000; // 5 минут

      if (age < maxAge) {
        console.log(`✅ [CACHE] Найдены результаты для: "${normalizedQuery}" (возраст: ${Math.round(age / 1000)}с)`);
        return cached.results;
      } else {
        console.log(`⏰ [CACHE] Результаты для "${normalizedQuery}" устарели (возраст: ${Math.round(age / 1000)}с)`);
        // Удаляем устаревшие результаты
        setCachedResults(prev => {
          const newCache = new Map(prev);
          newCache.delete(normalizedQuery);
          return newCache;
        });
      }
    }

    console.log(`❌ [CACHE] Нет результатов для: "${normalizedQuery}"`);
    return null;
  };

  // Очистить весь кэш
  const clearCache = () => {
    console.log('🗑️ [CACHE] Очищаем весь кэш результатов поиска');
    setCachedResults(new Map());
  };

  // Получить статистику кэша
  const getCacheStats = () => {
    const entries = Array.from(cachedResults.entries());
    return {
      totalQueries: entries.length,
      entries: entries.map(([query, data]) => ({
        query,
        resultsCount: data.results.length,
        age: Date.now() - data.timestamp
      }))
    };
  };

  return (
    <SearchResultsContext.Provider
      value={{
        cacheSearchResults,
        getCachedSearchResults,
        clearCache,
        getCacheStats
      }}
    >
      {children}
    </SearchResultsContext.Provider>
  );
};

export const useSearchResultsCache = () => {
  const context = useContext(SearchResultsContext);
  if (!context) {
    throw new Error('useSearchResultsCache должен использоваться внутри SearchResultsProvider');
  }
  return context;
};

export default SearchResultsContext;
